import { ConnectedRouter } from 'connected-react-router'
import { history } from 'duck/store'
import { FlagsmithProvider } from 'flagsmith-react'
import React, { useMemo } from 'react'
import ModalContainer from 'react-modal-promise'
import { QueryClient, QueryClientProvider } from 'react-query'
import { WithChildren } from 'utils-next/types'

import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'
import { CssBaseline, StyledEngineProvider, Theme, ThemeProvider } from '@mui/material'

import FlashNotice from './components/FlashNotice'
import { setupTheme } from './theme'

export type AppLibraryProviderProps = WithChildren

export const muiCache = createCache({
  key: 'mui',
  prepend: true,
})

export function AppLibraryProvider({ children }: AppLibraryProviderProps) {
  const queryClient = useMemo(() => new QueryClient(), [])
  const theme: Theme = React.useMemo(() => setupTheme(), [])

  return (
    <FlagsmithProvider
      environmentId={process.env.REACT_APP_FLAGSMITH_CLIENT_SIDE_ENVIRONMENT_KEY as string}
      api={process.env.REACT_APP_FLAGSMITH_API}
    >
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CacheProvider value={muiCache}>
            <QueryClientProvider client={queryClient}>
              <CssBaseline />
              <ConnectedRouter history={history}>{children}</ConnectedRouter>
              <FlashNotice />
              <ModalContainer />
            </QueryClientProvider>
          </CacheProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </FlagsmithProvider>
  )
}
